import React from 'react';

export function AnalyzeDropdownItem({ label, active, cached, loading, disabled, title, onClick }) {
  const blocked = !!disabled;
  return (
    <button
      className="btn btn-sm w-100 text-start d-flex align-items-center gap-2"
      style={{
        color: blocked ? '#475569' : (active || cached) ? '#4ade80' : '#e2e8f0',
        padding: '4px 12px 4px 28px',
        border: 'none',
        background: active ? 'rgba(74,222,128,0.1)' : 'transparent',
        fontSize: 12,
        opacity: loading ? 0.6 : 1,
        cursor: blocked ? 'not-allowed' : 'pointer',
      }}
      disabled={loading || blocked}
      title={title}
      onClick={onClick}
    >
      <span style={{ width: 16, textAlign: 'center', fontSize: 11 }}>
        {loading ? '⏳' : blocked ? '⊘' : cached ? '☑' : '☐'}
      </span>
      <span>{label}</span>
    </button>
  );
}

export default AnalyzeDropdownItem;
